import { render, staticRenderFns } from "./UploadCenterDocumentsModal.vue?vue&type=template&id=843d974c&scoped=true"
import script from "./UploadCenterDocumentsModal.vue?vue&type=script&lang=js"
export * from "./UploadCenterDocumentsModal.vue?vue&type=script&lang=js"
import style0 from "./UploadCenterDocumentsModal.vue?vue&type=style&index=0&id=843d974c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843d974c",
  null
  
)

export default component.exports